import Link from 'next/link';
import React from 'react';
import { Col, Row } from 'react-grid-system';
import styled from 'styled-components';
import { COLORS } from '../../theme';
import { Column } from '../Flex';
import GraphQLErrorText from '../GraphQLErrorText';
import Loading from '../Loading';

type StatusProps = {
  status: string;
};

const BotContainer = styled.div`
  background: transparent;
  opacity: ${(props: StatusProps) => (props.status === 'ACTIVE' ? '1' : '0.6')};
  cursor: pointer;
  box-sizing: border-box;
  margin: 1rem 0;
`;

const BotImage = styled.img`
  opacity: 1;
  height: 7.1875rem;
  width: 7.1875rem;
`;

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  justify-content: space-between;
`;

const BotName = styled.p`
  text-align: left;
  font: normal normal bold 19px/29px Poppins;
  letter-spacing: 0px;
  color: #111723;
  opacity: 1;
`;

const ListingsAmount = styled.p`
  font-family: Poppins;
  font-size: 11px;
  font-weight: medium;
  line-height: 17px;
  letter-spacing: 0px;
  color: ${COLORS.ACCENT};
  opacity: 1;
`;

const A = styled.a`
  text-decoration: none;
`;

type Props = {
  data: any;
  loading: boolean;
  error: any;
};

const GuidesBotList = (props: Props) => {
  if (props.loading) return <Loading />;
  if (props.error) return <GraphQLErrorText error={props.error} />;
  return (
    <Column>
      <Row>
        {props.data.map((b) => {
          return (
            <Col key={b.id} xs={12} md={6} lg={4} xxl={3}>
              <Link passHref href={`/bots/guides/bot/${b.id}`}>
                <A>
                  <BotContainer status={'ACTIVE'}>
                    <BotImage src={b.imageUrl} alt="" />
                    <TitleRow>
                      <BotName>{b.name}</BotName>
                    </TitleRow>
                  </BotContainer>
                </A>
              </Link>
            </Col>
          );
        })}
      </Row>
    </Column>
  );
};

export default GuidesBotList;
